export const ACTION_RESET = 'FETCH_CATEGORY_RESET';
export const ACTION_REQUEST = 'FETCH_CATEGORY_REQUEST';
export const ACTION_SUCCESS = 'FETCH_CATEGORY_SUCCESS';
export const ACTION_ERROR = 'FETCH_CATEGORY_ERROR';
